// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserReviewsManagement-space1-jnWAE {
	margin-bottom: 6px !important;
}

.UserReviewsManagement-space2-Fis8N {
	margin-bottom: 12px !important;
}

.UserReviewsManagement-space3-fsJyF {
	margin-bottom: 18px !important;
}

.UserReviewsManagement-space4-Kot9N {
	margin-bottom: 24px !important;
}

.UserReviewsManagement-space5-nlINZ {
	margin-bottom: 30px !important;
}

.UserReviewsManagement-space6-WoL7E {
	margin-bottom: 36px !important;
}

.UserReviewsManagement-space7-_zYH7 {
	margin-bottom: 42px !important;
}

.UserReviewsManagement-space8-okFXP {
	margin-bottom: 48px !important;
}

.UserReviewsManagement-spaceTop1-OovN9 {
	margin-top: 6px !important;
}

.UserReviewsManagement-spaceTop2-KWGhr {
	margin-top: 12px !important;
}

.UserReviewsManagement-spaceTop3-KT9ri {
	margin-top: 18px !important;
}

.UserReviewsManagement-spaceTop4-Nr491 {
	margin-top: 24px !important;
}

.UserReviewsManagement-spaceTop5-jYG2g {
	margin-top: 30px !important;
}

.UserReviewsManagement-spaceTop6-YoxPx {
	margin-top: 36px !important;
}

.UserReviewsManagement-spaceTop7-mDlmi {
	margin-top: 42px !important;
}

.UserReviewsManagement-spaceTop8-mn_T6 {
	margin-top: 48px !important;
}

.UserReviewsManagement-noMargin-zD4Ju {
	margin: 0px !important;
}

.UserReviewsManagement-padding1-WUH_O {
	padding-bottom: 6px !important;
}

.UserReviewsManagement-padding2-OVKUb {
	padding-bottom: 12px !important;
}

.UserReviewsManagement-padding3-C5bZf {
	padding-bottom: 18px !important;
}

.UserReviewsManagement-padding4-ms_Lt {
	padding-bottom: 24px !important;
}

.UserReviewsManagement-padding5-dZgZX {
	padding-bottom: 30px !important;
}

.UserReviewsManagement-padding6-MYPwR {
	padding-bottom: 36px !important;
}

.UserReviewsManagement-padding7-dfc4p {
	padding-bottom: 42px !important;
}

.UserReviewsManagement-paddingTop1-_xV5L {
	padding-top: 6px !important;
}

.UserReviewsManagement-paddingTop2-G5yNh {
	padding-top: 12px !important;
}

.UserReviewsManagement-paddingTop3-TKVOx {
	padding-top: 18px !important;
}

.UserReviewsManagement-paddingTop4-UqDHF {
	padding-top: 24px !important;
}

.UserReviewsManagement-paddingTop5-LwZt3 {
	padding-top: 30px !important;
}

.UserReviewsManagement-paddingTop6-hvlqG {
	padding-top: 36px !important;
}

.UserReviewsManagement-paddingTop7-fvHLb {
	padding-top: 42px !important;
}

.UserReviewsManagement-noPadding-ARu_g {
	padding: 0px !important;
}

.UserReviewsManagement-spaceMarginBottom0-HSGu4 {
	margin-bottom: 0;
}

.UserReviewsManagement-textBold-XSRnW {
	font-weight: 500 !important;
}

.UserReviewsManagement-textBolder-NLZz7 {
	font-weight: 700 !important;
}

.UserReviewsManagement-textNormal-CTl6Q {
	font-weight: normal !important;
}

/*New Design Text Colors */

.UserReviewsManagement-textDarkBlue-gRUq8 {
	color: rgb(20, 39, 94) !important;
}

.UserReviewsManagement-textLightBlue-yXtnY {
	color: rgb(57, 87, 106) !important;
}

.UserReviewsManagement-textLightSandleGreen-r8crw {
	color: rgb(76, 86, 41) !important;
}

.UserReviewsManagement-textLightBrown-yO8gn {
	color: rgb(115, 79, 33) !important;
}

.UserReviewsManagement-textMediumMaroon-iOCeK {
	color: rgb(87, 37, 51) !important;
}

.UserReviewsManagement-textBrown-oANFJ {
	color: rgb(160, 47, 24) !important;
}

.UserReviewsManagement-textMaroon-WGeS1 {
	color: rgb(155, 49, 67) !important;
}

.UserReviewsManagement-textDarkBrown-OSrai {
	color: rgb(83, 18, 16) !important;
}

.UserReviewsManagement-textMediumBrown-rT71f {
	color: rgb(142, 28, 10) !important;
}

.UserReviewsManagement-textSkyBlue-bb3mC {
	color: rgb(37, 117, 141) !important;
}

.UserReviewsManagement-textGray-yy9jO {
	color: rgb(77, 65, 51) !important;
}

.UserReviewsManagement-errorMessage-MLqL9 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.UserReviewsManagement-userText-hxOXp {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.UserReviewsManagement-panelHeader-krxQW {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.UserReviewsManagement-exportSection-Ld0l2 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.UserReviewsManagement-exportSectionGridSub-M5kwL {
	grid-template-columns: 50% 49% !important;
}

.UserReviewsManagement-exportText-7hgfL {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.UserReviewsManagement-exportLinkImg-OGEVr {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.UserReviewsManagement-exportImg-WOUqY {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.UserReviewsManagement-linkBtn-LOHd9 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.UserReviewsManagement-table-HwaLG {
	display: table;
}

.UserReviewsManagement-tableRow-HMUT6 {
	display: table-row;
}

.UserReviewsManagement-tableCell-XRrnV {
	display: table-cell;
	float: none;
}

.UserReviewsManagement-formGroup-yEx0g {
	margin-bottom: 6px;
}

.UserReviewsManagement-marginTop0-zyLdd {
	margin-top: 0;
}

.UserReviewsManagement-marginBottom20-oiGt1 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.UserReviewsManagement-bannerImageBg-CWF2K {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.UserReviewsManagement-bannerDelete-_GELo {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.UserReviewsManagement-exportLink-zCwIX {
	padding-top: 10px;
	padding-right: 10px;
}

.UserReviewsManagement-seachContent-pZCu3 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.UserReviewsManagement-marginBottom9-nA2_6 {
	margin-bottom: 9px;
}

.UserReviewsManagement-spaceTop52-b94QC {
	margin-top: 52px;
}

.UserReviewsManagement-profileViewInner-rTccP {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.UserReviewsManagement-profileViewMain-RC2e7 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.UserReviewsManagement-profileViewlabel-c2_Iq {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.UserReviewsManagement-profileViewMainContent-lPuKh {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.UserReviewsManagement-reviewsFormStar-L6ANN {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.UserReviewsManagement-reviewsFormStar-L6ANN svg {
	cursor: pointer;
}

.UserReviewsManagement-addLanguageText-gLLy6 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.UserReviewsManagement-exportSection-Ld0l2 {
		grid-template-columns: 100%;
	}

	.UserReviewsManagement-spaceTop52-b94QC {
		margin-top: 18px;
	}

	.UserReviewsManagement-exportText-7hgfL {
		float: none;
		margin-top: 12px;
	}

	.UserReviewsManagement-exportSectionGridSub-M5kwL {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.UserReviewsManagement-profileViewlabel-c2_Iq {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.UserReviewsManagement-profileViewMainContent-lPuKh {
		width: 100%;
		text-align: center;
	}

	.UserReviewsManagement-panelHeader-krxQW {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `UserReviewsManagement-space1-jnWAE`,
	"space2": `UserReviewsManagement-space2-Fis8N`,
	"space3": `UserReviewsManagement-space3-fsJyF`,
	"space4": `UserReviewsManagement-space4-Kot9N`,
	"space5": `UserReviewsManagement-space5-nlINZ`,
	"space6": `UserReviewsManagement-space6-WoL7E`,
	"space7": `UserReviewsManagement-space7-_zYH7`,
	"space8": `UserReviewsManagement-space8-okFXP`,
	"spaceTop1": `UserReviewsManagement-spaceTop1-OovN9`,
	"spaceTop2": `UserReviewsManagement-spaceTop2-KWGhr`,
	"spaceTop3": `UserReviewsManagement-spaceTop3-KT9ri`,
	"spaceTop4": `UserReviewsManagement-spaceTop4-Nr491`,
	"spaceTop5": `UserReviewsManagement-spaceTop5-jYG2g`,
	"spaceTop6": `UserReviewsManagement-spaceTop6-YoxPx`,
	"spaceTop7": `UserReviewsManagement-spaceTop7-mDlmi`,
	"spaceTop8": `UserReviewsManagement-spaceTop8-mn_T6`,
	"noMargin": `UserReviewsManagement-noMargin-zD4Ju`,
	"padding1": `UserReviewsManagement-padding1-WUH_O`,
	"padding2": `UserReviewsManagement-padding2-OVKUb`,
	"padding3": `UserReviewsManagement-padding3-C5bZf`,
	"padding4": `UserReviewsManagement-padding4-ms_Lt`,
	"padding5": `UserReviewsManagement-padding5-dZgZX`,
	"padding6": `UserReviewsManagement-padding6-MYPwR`,
	"padding7": `UserReviewsManagement-padding7-dfc4p`,
	"paddingTop1": `UserReviewsManagement-paddingTop1-_xV5L`,
	"paddingTop2": `UserReviewsManagement-paddingTop2-G5yNh`,
	"paddingTop3": `UserReviewsManagement-paddingTop3-TKVOx`,
	"paddingTop4": `UserReviewsManagement-paddingTop4-UqDHF`,
	"paddingTop5": `UserReviewsManagement-paddingTop5-LwZt3`,
	"paddingTop6": `UserReviewsManagement-paddingTop6-hvlqG`,
	"paddingTop7": `UserReviewsManagement-paddingTop7-fvHLb`,
	"noPadding": `UserReviewsManagement-noPadding-ARu_g`,
	"spaceMarginBottom0": `UserReviewsManagement-spaceMarginBottom0-HSGu4`,
	"textBold": `UserReviewsManagement-textBold-XSRnW`,
	"textBolder": `UserReviewsManagement-textBolder-NLZz7`,
	"textNormal": `UserReviewsManagement-textNormal-CTl6Q`,
	"textDarkBlue": `UserReviewsManagement-textDarkBlue-gRUq8`,
	"textLightBlue": `UserReviewsManagement-textLightBlue-yXtnY`,
	"textLightSandleGreen": `UserReviewsManagement-textLightSandleGreen-r8crw`,
	"textLightBrown": `UserReviewsManagement-textLightBrown-yO8gn`,
	"textMediumMaroon": `UserReviewsManagement-textMediumMaroon-iOCeK`,
	"textBrown": `UserReviewsManagement-textBrown-oANFJ`,
	"textMaroon": `UserReviewsManagement-textMaroon-WGeS1`,
	"textDarkBrown": `UserReviewsManagement-textDarkBrown-OSrai`,
	"textMediumBrown": `UserReviewsManagement-textMediumBrown-rT71f`,
	"textSkyBlue": `UserReviewsManagement-textSkyBlue-bb3mC`,
	"textGray": `UserReviewsManagement-textGray-yy9jO`,
	"errorMessage": `UserReviewsManagement-errorMessage-MLqL9`,
	"userText": `UserReviewsManagement-userText-hxOXp`,
	"panelHeader": `UserReviewsManagement-panelHeader-krxQW`,
	"exportSection": `UserReviewsManagement-exportSection-Ld0l2`,
	"exportSectionGridSub": `UserReviewsManagement-exportSectionGridSub-M5kwL`,
	"exportText": `UserReviewsManagement-exportText-7hgfL`,
	"exportLinkImg": `UserReviewsManagement-exportLinkImg-OGEVr`,
	"exportImg": `UserReviewsManagement-exportImg-WOUqY`,
	"linkBtn": `UserReviewsManagement-linkBtn-LOHd9`,
	"table": `UserReviewsManagement-table-HwaLG`,
	"tableRow": `UserReviewsManagement-tableRow-HMUT6`,
	"tableCell": `UserReviewsManagement-tableCell-XRrnV`,
	"formGroup": `UserReviewsManagement-formGroup-yEx0g`,
	"marginTop0": `UserReviewsManagement-marginTop0-zyLdd`,
	"marginBottom20": `UserReviewsManagement-marginBottom20-oiGt1`,
	"bannerImageBg": `UserReviewsManagement-bannerImageBg-CWF2K`,
	"bannerDelete": `UserReviewsManagement-bannerDelete-_GELo`,
	"exportLink": `UserReviewsManagement-exportLink-zCwIX`,
	"seachContent": `UserReviewsManagement-seachContent-pZCu3`,
	"marginBottom9": `UserReviewsManagement-marginBottom9-nA2_6`,
	"spaceTop52": `UserReviewsManagement-spaceTop52-b94QC`,
	"profileViewInner": `UserReviewsManagement-profileViewInner-rTccP`,
	"profileViewMain": `UserReviewsManagement-profileViewMain-RC2e7`,
	"profileViewlabel": `UserReviewsManagement-profileViewlabel-c2_Iq`,
	"profileViewMainContent": `UserReviewsManagement-profileViewMainContent-lPuKh`,
	"reviewsFormStar": `UserReviewsManagement-reviewsFormStar-L6ANN`,
	"addLanguageText": `UserReviewsManagement-addLanguageText-gLLy6`
};
module.exports = ___CSS_LOADER_EXPORT___;
